import { FormContinueButton } from "globalStyles/Containers";
import styled from "styled-components";

export const Toolbar = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;

  button {
    margin: 0;
    word-break: break-word;
  }
`;

export const CornerIcon = styled.div`
  position: absolute;

  svg {
    position: absolute;
    top: -85px;
    right: -140px;
  }
`;

export const PictureActionBlock = styled.div`
  opacity: ${({ isLoading }) => (isLoading ? 0.3 : 1)};
  position: relative;
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const PlaceHolder = styled.div`
  position: relative;
`;

export const PlaceholderContainer = styled.div`
  padding: 20px 0 19px;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1;
`;

export const PhotoLabel = styled.div`
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.05px;
  text-align: center;
  color: ${({ theme }) => theme.primaryColor};
`;

export const Button = styled(FormContinueButton)`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
`;
